module.exports = __webpack_public_path__ + "img/agri.a80cb568.png";